export default __webpack_public_path__ + "static/media/016-Australia.5d61e7b2.svg";